export default "__VITE_ASSET__Dv6S$O6t__"